// extracted by mini-css-extract-plugin
module.exports = {"head":"_5b10bb2305--head--mIspO"};